export type PlannerMode = 'financial_plan' | 'creative';

export const DEFAULT_PLANNER_MODE: PlannerMode = 'financial_plan';

export const PLANNER_MODE_LABELS: Record<PlannerMode, string> = {
  financial_plan: 'Financial plan',
  creative: 'Creative',
};

export const PLANNER_MODE_DESCRIPTIONS: Record<PlannerMode, string> = {
  financial_plan:
    'Builds the guided financial plan path with planning outputs and recommendations.',
  creative: 'Explores ideas, visuals, and scenarios with a more open-ended planning path.',
};

export const PLANNING_PRESETS_DESCRIPTION =
  'Use these presets to start a financial plan for common topics like retirement, taxes, or investments.';

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

function asPlannerMode(value: unknown): PlannerMode | null {
  return value === 'financial_plan' || value === 'creative' ? value : null;
}

export function plannerModeToCreativeMode(mode: PlannerMode): boolean {
  return mode === 'creative';
}

export function plannerModeFromCreativeMode(value: unknown): PlannerMode | null {
  if (value === true) return 'creative';
  if (value === false) return 'financial_plan';
  return null;
}

export function extractPlannerModeFromThreadState(state: unknown): PlannerMode | null {
  if (!isRecord(state)) return null;

  const metadata = isRecord(state.metadata) ? state.metadata : null;
  const values = isRecord(state.values) ? state.values : state;

  const storedPlannerMode =
    asPlannerMode(metadata?.plannerMode) ??
    asPlannerMode(metadata?.planner_mode) ??
    asPlannerMode(values.plannerMode) ??
    asPlannerMode(values.planner_mode);
  if (storedPlannerMode) return storedPlannerMode;

  return (
    plannerModeFromCreativeMode(values.creative_mode) ??
    plannerModeFromCreativeMode(values.creativeMode) ??
    plannerModeFromCreativeMode(metadata?.creative_mode) ??
    plannerModeFromCreativeMode(metadata?.creativeMode)
  );
}
